// @ts-nocheck
import { IconPresentationProps } from "@insite/mobius/Icon";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TextSeparatorPresentationProps } from "@store/Library/Components/Toolkit/TextSeparator";
import { boxStyles } from "@store/Themes/common/mixins/box";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Foundation Custom Code - Start */
import { BreakpointType, hiddenStyles } from "@store/Themes/common/mixins/common";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridItemProps } from "@insite/mobius/GridItem/GridItem";
import { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
/* Foundation Custom Code - End */

interface SignInSharedProps {
    wrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    icon?: IconPresentationProps;
    // Foundation Custom Code
    formTitle?: TypographyProps;
    requirementsGridItem?: GridItemProps;
    requirementsGridItemMobile?: GridItemProps;
}

export interface SignInProps extends SignInSharedProps {
    separator?: TextSeparatorPresentationProps;
    overlayOverrides?: SignInSharedProps;
}

/* Foundation Custom Code - Start */
const requirementsGridItemProps: GridItemProps = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        padding-left: ${pxToRem(50)};
                    `,
                ],
                mediaOptions.min,
            )}
    `,
};
/* Foundation Custom Code - End */

export const signInProps: SignInProps = {
    wrapper: {
        css: css`
            ${boxStyles(pxToRemArray([20, null, null, 25, 30]))};
            font-size: ${x => x.theme.design.typography.size.smaller};

            ${breakpoint("md")} {
                height: 100%;
            }
        `,
    },
    title: {
        variant: "h4",
        forwardAs: "h2",
        css: css`
            margin-top: 0;
        `,
    },
    icon: {
        color: "secondary",
        size: 60,
        css: spacingStyles(null, pxToRem(10)),
    },
    separator: {
        spacing: pxToRemArray([16]),
        extendedStyles: {
            text: {
                css: css`
                    font-size: ${x => x.theme.design.typography.size.smaller};
                    font-weight: ${x => x.theme.design.typography.weight.bold};
                    line-height: ${x => x.theme.design.typography.lineHeight.small};
                `,
            },
        },
    },
    overlayOverrides: {
        title: {
            forwardAs: "p",
            css: css`
                font-size: ${x => x.theme.design.typography.size.large} !important;
            `,
        },
    },
    /* Foundation Custom Code - Start */
    formTitle: {
        as: "h2",
        variant: "h4",
        css: css`
            margin-bottom: 1.5em;
        `,
    },
    requirementsGridItem: {
        ...requirementsGridItemProps,
        css: css`
            ${hiddenStyles(BreakpointType.Below, "sm")}
        `,
    },
    requirementsGridItemMobile: {
        ...requirementsGridItemProps,
        css: css`
            ${hiddenStyles(BreakpointType.Above, "md")}
        `,
    },
    /* Foundation Custom Code - End */
};
